import { ChangeDetectorRef, Component, inject, OnInit, DestroyRef } from "@angular/core";
import { IDashboardModel } from "@app/views-interfaces/dashboard-model.interface";
import { DashboardsService } from "@shared/index";
import { Subscription } from "rxjs";
import { T1SouthPanelComponent } from "../t1-south-panel";
import { JumpstartComponentsModule } from "@wk/components-v3-angular17";
import { SharedModule } from "@shared/shared.module";
import { TranslateModule } from "@ngx-translate/core";

import { productStringFromApplicationType } from "@app/views-interfaces/ApplicationType.enum";
import { CardModalService } from "@shared/card-modal/card-modal.service";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";

@Component({
    selector: "wk-south-panel",
    imports: [T1SouthPanelComponent, JumpstartComponentsModule, SharedModule, TranslateModule],
    templateUrl: "./south-panel.component.html",
    styleUrl: "./south-panel.component.scss",
    host: { class: "wk-cm__south-panel" },
})
export class SouthPanelComponent implements OnInit {
    private readonly destroyRef = inject(DestroyRef);
    private readonly dashboardsService = inject(DashboardsService);
    private readonly changeDetectorRef = inject(ChangeDetectorRef);
    public readonly cardModalService = inject(CardModalService);

    currentDashboard: IDashboardModel;
    currentDashboardChangedSubscription: Subscription;
    isT1 = false;
    constructor() {
        this.currentDashboardChangedSubscription = this.dashboardsService.currentDashboardChanged$
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(() => {
                this.init();
            });
    }

    ngOnInit() {
        this.init();
    }

    async init() {
        this.currentDashboard = await this.dashboardsService.getCurrentDashboard();
        this.isT1 = productStringFromApplicationType(this.currentDashboard.ApplicationType) === "T1";
        this.changeDetectorRef.detectChanges();
    }

    public okClicked() {
        this.cardModalService.saveForm.set(true);
    }

    public cancelClicked() {
        this.cardModalService.closeForm.set(true);
    }
}
